/* ============================================================
   cb-contact.js - Contactpagina (redesign 2026)

   Hoort bij sections/cb-contact.liquid. Drie taken:

   1. Het veld "Ordernummer" tonen bij de onderwerpen die het nodig
      hebben. Zonder dit script staat het veld er gewoon; dan is het
      een leeg veld te veel en niet een veld dat ontbreekt.
   2. De openingstijden uitrekenen: de rij van vandaag markeren en de
      statusregel in de hero invullen. Dat gebeurt hier en niet in
      Liquid, want Shopify cachet de HTML en dan zou er "nu
      bereikbaar" kunnen staan terwijl de winkel al uren dicht is.
   3. De Google-kaart pas laden na een klik. Google Maps zet cookies,
      dus de iframe komt er alleen als de bezoeker erom vraagt. Zonder
      dit script blijft het kaartvak verborgen en werkt de link eronder.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-cb-contact]');
  if (!root) return;

  /* ---- 1. Ordernummer ---- */

  var subject = root.querySelector('[data-cb-contact-subject]');
  var orderField = root.querySelector('[data-cb-contact-order]');

  if (subject && orderField) {
    var syncOrderField = function () {
      var option = subject.options[subject.selectedIndex];
      var needed = option && option.getAttribute('data-order') === 'true';
      orderField.hidden = !needed;
    };

    subject.addEventListener('change', syncOrderField);
    syncOrderField();
  }

  /* ---- 3. Kaart op verzoek (staat vóór 2, want 2 stopt met return) ---- */

  var map = root.querySelector('[data-cb-contact-map]');
  var mapButton = map ? map.querySelector('[data-cb-contact-map-load]') : null;

  if (map && mapButton) {
    map.hidden = false;
    mapButton.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.src = map.getAttribute('data-src');
      frame.title = map.getAttribute('data-title') || '';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      map.replaceChild(frame, mapButton);
    });
  }

  /* ---- 2. Openingstijden ---- */

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-cb-contact-day]'));
  if (!rows.length) return;

  var now = new Date();
  var today = now.getDay();
  var minutesNow = now.getHours() * 60 + now.getMinutes();

  /* "9:00 - 17:00" naar minuten sinds middernacht. Staat er niets, dan is
     het die dag dicht. */
  function parseRow(row) {
    var cell = row.querySelector('td');
    var text = cell ? cell.textContent.trim() : '';
    var match = text.match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})/);
    if (!match) return null;
    return {
      from: parseInt(match[1], 10) * 60 + parseInt(match[2], 10),
      to: parseInt(match[3], 10) * 60 + parseInt(match[4], 10)
    };
  }

  var todayRow = null;
  rows.forEach(function (row) {
    if (parseInt(row.getAttribute('data-cb-contact-day'), 10) === today) {
      row.classList.add('cb-contact__hour--today');
      todayRow = row;
    }
  });

  var status = root.querySelector('[data-cb-contact-status]');
  var statusText = root.querySelector('[data-cb-contact-status-text]');
  if (!status || !statusText) return;

  var open = false;
  var hours = todayRow ? parseRow(todayRow) : null;
  if (hours && minutesNow >= hours.from && minutesNow < hours.to) {
    open = true;
  }

  statusText.textContent = root.getAttribute(open ? 'data-open-label' : 'data-closed-label');
  status.classList.toggle('cb-contact__status--open', open);
  status.hidden = false;
})();
